import React, {useCallback, useEffect, useState} from 'react';
import {FieldErrors, ValidationRules} from "react-hook-form";
import {FormFeedback} from "reactstrap";
import {deepFinder, hasDots} from "../../../Utils/Utils";

interface Prop {
  name?: string,
  errors: FieldErrors,
  rules: ValidationRules
}

const InputErrorsComponent: React.FC<Prop> = ({name, errors, rules}) => {

  const [state, setState] = useState({
    isMin: false,
    isMax: false,
    isMinLength: false,
    isMaxLength: false,
    isRequired: false,
    isMinMax: false,
    isMinMaxLength: false,
    isValidation: false,
    isCustom: false,
  });

  const isErrorType = useCallback( (type: string): boolean => {
    if (!name) return false;
    if (hasDots(name)) return deepFinder(errors, name)?.type === type;
    return errors[name]?.type === type;
  }, [name, errors]);

  useEffect(() => {
    let minMax = rules.min !== undefined && rules.max !== undefined;

    if (name && errors[name]) {
      setState({
        isRequired: isErrorType("required"),
        isValidation: isErrorType("pattern") || isErrorType("validate"),
        isMin: isErrorType("min"),
        isMax: isErrorType("max"),
        isMinMax: (isErrorType("min") || isErrorType("max")) && minMax,
        isMinLength: isErrorType("minLength"),
        isMaxLength: isErrorType("maxLength"),
        isMinMaxLength: isErrorType("minLength") || isErrorType("maxLength"),
        isCustom: isErrorType("custom")
      });
    }
  }, [errors, name, isErrorType, rules]);

  return (
    <>
      {state.isRequired && <FormFeedback>El campo es requerido</FormFeedback>}
      {state.isValidation && <FormFeedback>El campo es inválido</FormFeedback>}
      {state.isMin && !state.isMinMax && <FormFeedback>El campo debe ser mayor/igual {rules.min ? parseInt(rules.min as string) : rules.min }</FormFeedback>}
      {state.isMax && !state.isMinMax && <FormFeedback>El campo debe ser menor/igual {rules.max}</FormFeedback>}
      {state.isMinMax && <FormFeedback>El campo debe estar entre {rules.min} y {rules.max}</FormFeedback>}
      {state.isMinMaxLength && <FormFeedback>El campo debe tener entre {rules.minLength} y {rules.maxLength} caracteres</FormFeedback>}
      {state.isMinLength && !state.isMinMaxLength && <FormFeedback>El campo debe tener mínimo {rules.minLength} carácteres</FormFeedback>}
      {state.isMaxLength && !state.isMinMaxLength && <FormFeedback>El campo debe tener máximo {rules.maxLength} carácteres</FormFeedback>}
      {state.isCustom  &&
      <FormFeedback>{
        hasDots(name!) ? deepFinder(errors, name!)?.message : errors[name!]?.message
      }</FormFeedback>}

      {/*{ !state.isRequired && isRequired && <FormFeedback>El campo es requerido</FormFeedback>}*/}
      {/*{isValidation && <FormFeedback>El campo es invalido</FormFeedback>}*/}
      {/*{isMinLength && !isMinMaxLength && <FormFeedback>El campo debe tener minimo {rules.minLength} caracteres</FormFeedback>}*/}
      {/*{isMaxLength && !isMinMaxLength &&<FormFeedback>El campo debe tener maximo {rules.maxLength} caracteres</FormFeedback>}*/}
      {/*{isMinMaxLength && <FormFeedback>El campo debe tener {rangeMessage()}</FormFeedback>}*/}
    </>
  );
};

export default InputErrorsComponent;
